import type { PlayerId } from '../engine/types';

export type MatchMode = 'bot' | 'network';
export type ResultTrust = 'local' | 'peer-confirmed' | 'server-verified';
export type ParticipantKind = 'human' | 'bot';

export interface MatchParticipant {
  readonly side: PlayerId;
  readonly kind: ParticipantKind;
  readonly displayName: string | null;
  readonly networkPlayerId: string | null;
}

/** Presentation and product metadata. It never enters simulation state/checksum. */
export interface MatchContext {
  readonly matchId: string;
  readonly mode: MatchMode;
  readonly resultTrust: ResultTrust;
  readonly networkMatchId: string | null;
  readonly localSide: PlayerId;
  readonly participants: Readonly<Record<PlayerId, MatchParticipant>>;
}

export function createBotMatchContext(matchId: string, playerName: string): MatchContext {
  return Object.freeze({
    matchId,
    mode: 'bot',
    resultTrust: 'local',
    networkMatchId: null,
    localSide: 'player',
    participants: Object.freeze({
      player: Object.freeze({ side: 'player', kind: 'human', displayName: playerName, networkPlayerId: null }),
      bot: Object.freeze({ side: 'bot', kind: 'bot', displayName: null, networkPlayerId: null }),
    }),
  });
}
